import { createSelector } from 'reselect'
import { isBefore, startOfDay } from 'date-fns'

import RootState from '../types'
import { SearchbarHistoryItem } from './types'

const _getSearchbarState = (state: RootState) => state.searchbar

const filterItemsByToday = (historyItems: SearchbarHistoryItem[]): SearchbarHistoryItem[] => {
    const today = startOfDay(new Date())
    return historyItems.filter(item => {
        if (!item.arrival) {
            return true
        }
        return !isBefore(item.arrival, today)
    })
}

export const getSearchbarHistoryItemsState = createSelector(_getSearchbarState, searchbarHistory =>
    filterItemsByToday(searchbarHistory.historyItems),
)
